import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getCardSlideStyles = props => {
  var heightConfig = props.heightConfig,
    isLargeScreen = props.isLargeScreen,
    aspectRatio = props.aspectRatio;
  var cardSlideTitleTopMargin = isLargeScreen ? tokens.spacing.SPACING_20 : tokens.spacing.SPACING_12;
  return StyleSheet.create({
    cardSlideImage: Object.assign({
      width: '100%',
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16
    }, aspectRatio ? {
      aspectRatio
    } : heightConfig && {
      minHeight: isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile
    }),
    cardSlideTitle: {
      marginTop: cardSlideTitleTopMargin
    }
  });
};